import { Suspense } from "react";

import { config } from "@/config";
import { NavigationRail, NavigationItem } from "@yaradigitallabs/ahua-react";

type SidebarProps = {
  routes: Array<{
    id: string;
    text: string;
    icon: string;
    selected: boolean;
    url: string;
  }>;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  selected: string;
  setSelected: (selected: string) => void;
};

const Sidebar = ({
  routes,
  collapsed,
  setCollapsed,
  selected,
  setSelected,
}: SidebarProps) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="flex min-h-[calc(100vh-60px)] max-h-0">
        <NavigationRail onChange={(value) => setCollapsed(value)}>
          <NavigationRail.Middle>
            {routes.map((item) => {
              return (
                <NavigationRail.Item
                  key={item.id}
                  onClick={() => setSelected(item.url)}
                  selected={selected === item.url}
                  className="mb-2"
                >
                  <NavigationItem.Head>
                    <NavigationItem.Icon icon={item.icon} />
                  </NavigationItem.Head>
                  {!collapsed && (
                    <NavigationItem.Body>{item.text}</NavigationItem.Body>
                  )}
                </NavigationRail.Item>
              );
            })}
          </NavigationRail.Middle>
          <NavigationRail.Separator />
          <NavigationRail.End>
            <NavigationRail.CollapseItem />
            <a
              href={config.monitoringPageUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <NavigationRail.Item>
                <NavigationItem.Head>
                  <NavigationItem.Icon icon="ExternalLink" />
                </NavigationItem.Head>
                {!collapsed && (
                  <NavigationItem.Body size={"s"}>
                    Monitoring
                  </NavigationItem.Body>
                )}
              </NavigationRail.Item>
            </a>
            <a
              href={config.dashboardPageUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <NavigationRail.Item>
                <NavigationItem.Head>
                  <NavigationItem.Icon icon="ExternalLink" />
                </NavigationItem.Head>
                {!collapsed && (
                  <NavigationItem.Body size={"s"}>
                    Dashboard
                  </NavigationItem.Body>
                )}
              </NavigationRail.Item>
            </a>
            <NavigationRail.Item>
              <NavigationItem.Head>
                <NavigationItem.Icon icon="Settings" />
              </NavigationItem.Head>
              {!collapsed && (
                <NavigationItem.Body size={"s"}>Settings</NavigationItem.Body>
              )}
            </NavigationRail.Item>

            <NavigationRail.Item>
              <NavigationItem.Head>
                <NavigationItem.Icon icon="Privacy" />
              </NavigationItem.Head>
              {!collapsed && (
                <NavigationItem.Body size={"s"}>
                  Privacy Notice
                </NavigationItem.Body>
              )}
            </NavigationRail.Item>
          </NavigationRail.End>
        </NavigationRail>
      </div>
    </Suspense>
  );
};
export default Sidebar;
